import { useTheme } from '@chakra-ui/react';
import styled from 'styled-components';

const CustomTooltipContainer = styled.div`
  background-color: #fff;
  box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.15);
  border: 0.5px solid rgba(0, 0, 0, 0.1);
  padding: 8px;
  border-radius: 5px;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
`;

const ColorDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
  background-color: ${({ color }) => color};
`;

const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const TooltipLabel = styled.p`
  font-size: 12px;
  font-weight: 600;
  color: #333;
  margin: 0;
  font-family: 'Inter', sans-serif;
`;

const TooltipHeading = styled.p`
  font-size: 11px;
  font-weight: 600;
  color: #777;
  margin: 0 0 6px 0;
  font-family: 'Inter', sans-serif;
`;

export interface CustomTooltipProps {
  active?: boolean;
  payload?: any;
  label?: string;
  yAxisLabel?: string;
  formatValue?: (value: number, label: string) => string;
}

const CustomTooltip = ({
  active,
  payload,
  label,
  yAxisLabel = '',
  formatValue,
}: CustomTooltipProps = {}) => {
  const { colors } = useTheme();

  if (active && payload && payload.length) {
    return (
      <CustomTooltipContainer>
        <TooltipHeading>{label}</TooltipHeading>
        {payload?.map((item: any, index: number) => {
          const { value, name, color } = item;
          const formattedValue = formatValue
            ? formatValue(value, yAxisLabel)
            : value.toLocaleString();
          return (
            <LabelWrapper key={index}>
              <ColorDot color={color || item.fill} />
              <TooltipLabel>{`${name}: ${formattedValue}`}</TooltipLabel>
            </LabelWrapper>
          );
        })}
      </CustomTooltipContainer>
    );
  }

  return null;
};

export default CustomTooltip;
